import { currency, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import React from "react";

interface ProfitEstimateProps {
  profitEstimate: number;
  profitEstimatePercent: number;
}

const ProfitEstimate = (props: ProfitEstimateProps) => {
  return (
    <React.Fragment>
      <span className={props.profitEstimate > 0 ? "" : "text-red"}>
        {currency.formatByWorkspace(props.profitEstimate)}
      </span>
      <span className="ml-1 text-gray-600 w-14">
        ({percent.format(props.profitEstimatePercent)})
      </span>
    </React.Fragment>
  );
};

export default observer(ProfitEstimate);
